;(function() {
  'use strict'

  angular.module('core.spinner', [])
})()
